import { useEffect, useState } from 'react'
import { Grid, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppRoutes } from "../routes/route.path";
import setToast from "../../helpers/toaster.helper";
import { ToasterTexts, appNote, buttonLabels } from '../shared/constants';
import { ToasterType } from '../shared/toaster/toaster.model';
import SettingsHeader from "./settingsHeader.component";
import ButtonComponent from "../shared/button/button.component";
import { LowCreditSettingsModel, mapToLowCreditSettingsModel, Setting } from '../../models/settings-model';
import { SettingsService } from "../../services/SettingsService";
import * as selector from "../../selectors/selectors";
import CustomSwitch from '../shared/switch.component';
import { UserService } from '../../services/UserService';
import { updateLowCreditSettings } from '../../reducers/reducer';
import { UsageModel } from '../../models/plan-metrics.model';

const LowCreditNotification = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const LowCreditSettings: LowCreditSettingsModel = useSelector(selector.lowCreditSettings)
    const NormalTextingUsage: UsageModel = useSelector(selector.normalTextingUsage)
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [normalCredits, setNormalCredit] = useState<number | null>()
    const [groupCredits, setGroupCredits] = useState<number | null>(LowCreditSettings?.GroupCredits)
    const [isSwitchEnable, setIsSwitchEnable] = useState<boolean>(LowCreditSettings?.EmailAlertEnabled);
    const [enableAction, setEnableActions] = useState<boolean>(false)

    const onSubmit = (event: any) => {
        event.preventDefault();
        setIsLoading(true)
        let data = {
            organizationId: UserService.getCurrentUserFromLocalStorage()?.OrgId,
            groupCredits: isSwitchEnable ? groupCredits >= 0 ? groupCredits : null : null,
            NormalCredits: isSwitchEnable ? normalCredits >= 0 ? normalCredits : null : null,
            emailAlertEnabled: isSwitchEnable
        }
        SettingsService.updateLowCreditNotifcationSettings(data).then((res) => {
            dispatch(updateLowCreditSettings(mapToLowCreditSettingsModel(res.data)))
            setGroupCredits(res.data.groupCredits)
            setNormalCredit(res.data.normalCredits)
            setIsSwitchEnable(res.data.emailAlertEnabled)
            setIsLoading(false);
            setToast(ToasterTexts.LOW_CREDIT_NUMBER, ToasterType.SUCCESS)
            setEnableActions(false)
        }).catch((err) => {
            setIsLoading(false)
        })
    }

    const handleKeyPress = (e) => {
        if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+' || e.key === '.') {
            e.preventDefault();
        }
    }

    const cancel = () => {
        setGroupCredits(LowCreditSettings?.GroupCredits)
        setNormalCredit(LowCreditSettings?.NormalCredits)
        setIsSwitchEnable(LowCreditSettings?.EmailAlertEnabled)
        setEnableActions(false)
    }

    useEffect(() => {
        setNormalCredit(NormalTextingUsage.PlanCredits == -1 ? null : LowCreditSettings?.NormalCredits)
        setGroupCredits(LowCreditSettings?.GroupCredits)
        setIsSwitchEnable(LowCreditSettings?.EmailAlertEnabled)
    }, [LowCreditSettings])

    return (
        <>
            <div className={`m-auto`}>
                <div className={`d-flex justify-between w-p-100  ${IsMobileDevice ? "" : "mt-2"}`}>
                    <SettingsHeader IsMobileDevice={IsMobileDevice} Title={"Low Credit Notification"} subTitle={appNote.LOW_CREDIT_MESSAGE} />
                    <div className={`d-flex align-center ${IsMobileDevice ? "bg-color-secondary bb-primary-divider-4" : ""}`}>
                        <CustomSwitch
                            checked={isSwitchEnable}
                            onChange={(checked: boolean) => { setIsSwitchEnable(checked); setEnableActions(true) }}
                        />
                    </div>
                </div>
                <div className={`${IsMobileDevice ? "" : "my-1 bb-primary-divider-4"}`}></div>
                <div className={`${IsMobileDevice ? 'py-3 px-3' : ''} `}>
                    {!!IsMobileDevice && <div className="h5-regular my-2">{appNote.LOW_CREDIT_MESSAGE}</div>}
                    <div className="my-2">
                        <form onSubmit={onSubmit}>
                            {!(!isSwitchEnable || NormalTextingUsage.PlanCredits == -1) && <Grid container>
                                <TextField
                                    disabled={(!isSwitchEnable || NormalTextingUsage.PlanCredits == -1)}
                                    type="number"
                                    placeholder=""
                                    label="1-1 Credits"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={normalCredits ?? ""}
                                    className="br-1 w-fill"
                                    onKeyPress={(e) => handleKeyPress(e)}
                                    onChange={(e) => { setNormalCredit(e.target.value === "" ? null : Number(e.target.value)); setEnableActions(true) }}
                                />
                            </Grid>}
                            <Grid container>
                                <TextField
                                    disabled={!isSwitchEnable}
                                    type="number"
                                    placeholder=""
                                    label="Group Credits"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={groupCredits ?? ""}
                                    className="br-1 w-fill mt-2"
                                    onKeyPress={(e) => handleKeyPress(e)}
                                    onChange={(e) => { setGroupCredits(e.target.value === "" ? null : Number(e.target.value)); setEnableActions(true) }}
                                />
                            </Grid>
                        </form>
                    </div>
                    <div>
                        <Grid container>
                            <Grid item xs={12} className={`d-flex mt-2 ${IsMobileDevice ? '' : 'justify-flex-end'}`} >
                                <ButtonComponent
                                    Variant={!enableAction ? "disabled-btn-small" : "secondary-btn-small"}
                                    ClassName={`c-pointer mr-1 ${IsMobileDevice ? 'w-100' : ''}`}
                                    OnClick={() => cancel()}
                                    ButtonLabel={buttonLabels.CANCEL}
                                />
                                <ButtonComponent
                                    Variant={(!enableAction ? true : isSwitchEnable ? !(isSwitchEnable && (!!normalCredits || !!groupCredits)) : false) ? "disabled-btn-small" : "primary-btn-small"}
                                    ClassName={`c-pointer w-space ${IsMobileDevice ? 'w-100' : ''}`}
                                    OnClick={onSubmit}
                                    ButtonLabel={buttonLabels.SAVE}
                                    Loading={isLoading}
                                />
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LowCreditNotification